import { AppTheme } from "../tokens";
import { lightTheme } from "./light";

export const darkTheme: AppTheme = {
  ...lightTheme,
  mode: "dark",
  palette: {
    ...lightTheme.palette,
  },
  antd: {
    ...lightTheme.antd,
  },
};
